import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Handshake } from "@phosphor-icons/react";
import CronogramaBadge from "@/components/CronogramaBadge";

const COP = (n) => new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(n || 0);

export default function MiComision() {
    const [items, setItems] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        api.get("/mis-proyectos-comercial")
            .then(r => setItems(r.data))
            .catch(e => setError(e.response?.data?.detail || "No se pudo cargar la información"));
    }, []);

    const totalComisiones = (items || []).reduce((a, it) => a + (it.monto_calculado_cop || 0), 0);

    return (
        <div className="max-w-5xl mx-auto p-4 md:p-8" data-testid="mi-comision-page">
            <div className="overline mb-1" style={{ color: "#0F766E" }}>Mis proyectos</div>
            <h1 className="font-display text-4xl font-black tracking-tighter mb-2">Mi comisión</h1>
            <p className="text-sm text-zinc-600 mb-8">Comisión calculada según el porcentaje asignado en cada proyecto. Solo tú ves esta información.</p>

            {error && <div className="border border-red-300 bg-red-50 p-4 text-sm text-red-700 font-mono">{error}</div>}
            {!items && !error && <div className="text-sm text-zinc-400">Cargando…</div>}
            {items && items.length === 0 && (
                <div className="border border-zinc-200 p-8 text-center text-zinc-400">
                    <Handshake size={32} className="mx-auto mb-2" />
                    Todavía no tienes una comisión asignada en ningún proyecto.
                </div>
            )}

            {items && items.length > 0 && (
                <>
                    <div className="border border-zinc-200 p-5 mb-4" style={{ background: "#F0FDFA" }}>
                        <div className="overline mb-1">Total comisiones activas</div>
                        <div className="font-display text-3xl font-black tracking-tighter">{COP(totalComisiones)}</div>
                    </div>
                    <div className="border border-zinc-200 overflow-x-auto">
                        <table className="atia-table">
                            <thead>
                                <tr>
                                    <th>Cliente</th>
                                    <th>Proyecto</th>
                                    <th>Cronograma</th>
                                    <th>% Comisión</th>
                                    <th>Monto calculado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map(it => (
                                    <tr key={it.subscription_id}>
                                        <td className="font-semibold">{it.razon_social}</td>
                                        <td className="text-zinc-600 text-sm">{it.nombre_proyecto || "-"}</td>
                                        <td><CronogramaBadge cronograma={it.cronograma} /></td>
                                        <td className="font-mono">{it.porcentaje}%</td>
                                        <td className="font-mono font-bold">{COP(it.monto_calculado_cop)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </div>
    );
}
